import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export interface CategoriaMensagem {
  id: number;
  nome: string;
  descricao?: string;
  validadeDias?: number;
  rodape?: "PREFERENCIA" | "SR" | null;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * 🔹 Listar todas as categorias de mensagem
 */
export const listarCategoriasMensagemService = async (): Promise<
  CategoriaMensagem[] | undefined
> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/categorias-mensagens`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error("Erro ao listar categorias de mensagem:", error);
    }
  }
};

/**
 * 🔹 Buscar categoria por ID
 */
export const buscarCategoriaMensagemPorIdService = async (
  id: number
): Promise<CategoriaMensagem | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/categorias-mensagens/${id}`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error("Erro ao buscar categoria de mensagem:", error);
    }
  }
};

/**
 * 🔹 Criar nova categoria de mensagem
 */
export const criarCategoriaMensagemService = async (
  categoriaData: Partial<CategoriaMensagem>
): Promise<CategoriaMensagem | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/categorias-mensagens`;
    try {
      const response = await axios.post(URL, categoriaData, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error("Erro ao criar categoria de mensagem:", error);
    }
  }
};

/**
 * 🔹 Atualizar categoria de mensagem existente
 */
export const atualizarCategoriaMensagemService = async (
  id: number,
  categoriaData: Partial<CategoriaMensagem>
): Promise<CategoriaMensagem | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/categorias-mensagens/${id}`;
    try {
      const response = await axios.put(URL, categoriaData, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error("Erro ao atualizar categoria de mensagem:", error);
    }
  }
};

/**
 * 🔹 Excluir categoria
 */
export const excluirCategoriaMensagemService = async (
  id: number
): Promise<void> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/categorias-mensagens/${id}`;
    try {
      await axios.delete(URL, {
        headers: { Authorization: Token.AuthStr },
      });
    } catch (error) {
      console.error("Erro ao excluir categoria de mensagem:", error);
    }
  }
};

/**
 * 🔹 Exporta o objeto unificado (boa prática)
 */
export const categoriaMensagemService = {
  listarCategoriasMensagemService,
  buscarCategoriaMensagemPorIdService,
  criarCategoriaMensagemService,
  atualizarCategoriaMensagemService,
  excluirCategoriaMensagemService,
};
